// extracted by mini-css-extract-plugin
export var counterButton = "Counter-module--counterButton--cad93";
export var counterContainer = "Counter-module--counterContainer--fcb61";
export var counterNumber = "Counter-module--counterNumber--ac6bc";